import { cubicBezier } from '@styles/vars/cubicBezier.style'
import styled from 'styled-components'

export const LogoSvg = styled.svg`
  path {
    transition: fill 0.2s ${cubicBezier.inOut}
      ${props => (props.mobileNavIsOpen ? '0.1s' : '0.1s')};
  }
`
